import React from "react";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import Pagination from "react-js-pagination";
import { translateProfileFields } from "../../helpers/utility";

const styles = {
  tableWrapper: {
    minWidth: 750,
    overflow: "auto"
  },
  table: {
    width: "100%",
    fontFamily: "IranYekanRegular",
    direction: "ltr"
  },
  tableHeaderColumn: {
    textAlign: "center",
    fontFamily: "IranYekanRegular"
  },
  tableRowColumn: {
    textAlign: "center",
    fontFamily: "IranYekanRegular"
  },
  erroneous: {
    backgroundColor: "#f55"
  },
  successful: {},
  numberColumn: {
    width: 75,
    paddingLeft: 2,
    paddingRight: 2
  },
  paginationWrapper: {
    display: "flex",
    justifyContent: "center"
  }
};

const tableSettings = {
  selectable: false
};

const numberOfItemsPerPage = 50;

const UploadedStudentsTable = ({
  students = [],
  activePage,
  setActivePage,
  numberOfPages,
  totalItemsCount
}) => {
  const HeaderRows = (
    <TableRow>
      <TableRowColumn
        style={{ ...styles.tableRowColumn, ...styles.numberColumn }}
      >
        ردیف
      </TableRowColumn>
      <TableHeaderColumn style={styles.tableHeaderColumn}>
        کد ملی
      </TableHeaderColumn>
      <TableHeaderColumn style={styles.tableHeaderColumn}>
        نام
      </TableHeaderColumn>
      <TableHeaderColumn style={styles.tableHeaderColumn}>
        نام خانوادگی
      </TableHeaderColumn>
      <TableHeaderColumn style={styles.tableHeaderColumn}>
        مقطع تحصیلی
      </TableHeaderColumn>
      <TableHeaderColumn style={styles.tableHeaderColumn}>
        جنسیت
      </TableHeaderColumn>
    </TableRow>
  );

  return (
    <div style={styles.tableWrapper}>
      <Table {...tableSettings}>
        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
          {HeaderRows}
        </TableHeader>
        <TableBody displayRowCheckbox={false}>
          {students.map((student, i) => {
            return (
              <TableRow
                selectable={false}
                style={
                  student.successful ? styles.successful : styles.erroneous
                }
                key={`${i}-${student.national_number}`}
              >
                <TableRowColumn
                  style={{ ...styles.tableRowColumn, ...styles.numberColumn }}
                >
                  {(activePage - 1) * numberOfItemsPerPage + i + 1}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumn}>
                  {student.national_number}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumn}>
                  {student.first_name}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumn}>
                  {student.last_name}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumn}>
                  {student.grade}
                </TableRowColumn>
                <TableRowColumn style={styles.tableRowColumn}>
                  {translateProfileFields(student.gender)}
                </TableRowColumn>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {numberOfPages > 1 && (
        <div style={styles.paginationWrapper}>
          <Pagination
            activePage={activePage}
            itemsCountPerPage={numberOfItemsPerPage}
            totalItemsCount={totalItemsCount}
            pageRangeDisplayed={numberOfPages}
            onChange={setActivePage}
            itemClass="pagination-item"
            innerClass="pagination"
          />
        </div>
      )}
    </div>
  );
};

class UploadedStudentsTableContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1
    };
  }

  setActivePage = activePage => this.setState({ activePage });

  getItemsIndexesOfCurrentPage = activePage => {
    const startIndex = (parseInt(activePage, 10) - 1) * numberOfItemsPerPage;
    return [startIndex, startIndex + numberOfItemsPerPage];
  };

  getItemsOfCurrentPage = () => {
    const { students = [] } = this.props;
    const { activePage } = this.state;
    const [startIndex, finishIndex] = this.getItemsIndexesOfCurrentPage(
      activePage
    );
    const currentStudents = students.slice(startIndex, finishIndex);
    return currentStudents;
  };

  render() {
    const { activePage } = this.state;
    const { students = [] } = this.props;

    if (!students || students.length === 0) return null;

    const numberOfPages =
      parseInt(students.length / numberOfItemsPerPage, 10) + 1;

    return (
      <UploadedStudentsTable
        students={this.getItemsOfCurrentPage()}
        activePage={activePage}
        setActivePage={this.setActivePage}
        numberOfPages={numberOfPages}
        totalItemsCount={students.length}
      />
    );
  }
}

export default UploadedStudentsTableContainer;



// WEBPACK FOOTER //
// ./src/components/school/UploadedStudentsTable.js